import * as Actions from './types';

const initState = {
  form: {
  },
  sort: {
    key: 'student_id',
    asc: true,
  },
  page: 0,
  totalElements: 0,
  totalPages: 0,
  pageSize: 20,
  numberOfElements: 0,
  data: [],
  init: false,
  submitting: false,
  done: false,
};

const StudentListList = (state = initState, action) => {
  switch (action.type) {
    case Actions.CLEAR_ONE:
      return {
        ...initState,
      };
    case Actions.STUDENTS_FETCH_LIST:
      return {
        ...state,
        init: true,
        data: action.data.items,
        page: (action.data.meta.currentPage - 1), // zero-based
        totalElements: action.data.meta.totalCount,
        totalPages: action.data.meta.pageCount,
        numberOfElements: action.data.items.length,
        submitting: false,
        done: true,
      };
    case Actions.STUDENTS_SORT_CHANGE:
      return {
        ...state,
        submitting: true,
        done: false,
        sort: action.sort,
      };
    case Actions.STUDENTS_SEARCH_FORM_SUBMIT:
      return {
        ...state,
        submitting: true,
        done: false,
        form: {
          ...initState.form,
          ...action.form,
        },
      };
    case Actions.STUDENTS_PAGE_CHANGE:
      return {
        ...state,
        submitting: true,
        done: false,
        page: action.page,
      };
    default:
      return state;
  }
};
export default StudentListList;
